import { YearGroup, CurriculumSubject, CurriculumTopic, PreGeneratedCard } from '../types/Curriculum';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://api.brainbreakcards.com';

async function get<T>(path: string): Promise<T> {
  const res = await fetch(`${API_BASE_URL}${path}`);
  if (!res.ok) throw new Error(`API error ${res.status}`);
  return res.json();
}

export const curriculumApi = {
  async getYears(): Promise<YearGroup[]> {
    const data = await get<{ years: YearGroup[] }>('/api/curriculum/years');
    return data.years;
  },

  async getSubjects(year: number): Promise<CurriculumSubject[]> {
    const data = await get<{ subjects: CurriculumSubject[] }>(`/api/curriculum/${year}/subjects`);
    return data.subjects;
  },

  async getTopics(year: number, subject: string): Promise<CurriculumTopic[]> {
    const data = await get<{ topics: CurriculumTopic[] }>(`/api/curriculum/${year}/${subject}/topics`);
    return data.topics;
  },

  async getCards(topicId: string): Promise<PreGeneratedCard[]> {
    const data = await get<{ cards: PreGeneratedCard[] }>(`/api/curriculum/topics/${topicId}/cards`);
    return data.cards;
  },
};
